// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3XZqC","footer":"ChangeClinic_footer__3ldY9"};